// @flow
import * as React from "react"
import { FormattedMessage } from "react-intl"
import { connect } from "react-redux"
import { TweenMax, Cubic } from "gsap"
import { setModal } from "../../Modal"
import type { Match, RouterHistory } from "react-router-dom"
import type { SetModal } from "../../Modal"

import {
  Container,
  Modal,
  Content,
  ConfirmBody,
  Header,
  PrimaryHeading,
  SecondaryHeading,
  PrimaryButton,
  ButtonGroup,
  Fade
} from "../Modal"

type Props = {
  match: Match,
  setModal: SetModal,
  history: RouterHistory
}

class ConfirmationModal extends React.Component<Props> {
  body: ?HTMLElement
  fade: ?HTMLElement

  constructor(props) {
    super(props)
    this.body = null
    this.fade = null
  }

  componentDidMount = () => {
    TweenMax.set(this.body, { y: "-=50", opacity: 0 })
    TweenMax.set(this.fade, { opacity: 0 })
    TweenMax.to(this.body, 0.5, { ease: Cubic.easeOut, opacity: 1, y: 0 })
    TweenMax.to(this.fade, 0.5, { ease: Cubic.easeOut, opacity: 1 })
  }

  handleConfirm = () => {
    this.dismiss()
  }

  dismiss = () => {
    const { history, setModal } = this.props
    setModal(false)
    TweenMax.to(this.body, 0.5, { ease: Cubic.easeOut, opacity: 0, y: "+=50" })
    TweenMax.to(this.fade, 0.5, {
      ease: Cubic.easeOut,
      opacity: 0,
      onComplete: () => {
        history.goBack()
      }
    })
  }

  render() {
    const { match } = this.props
    const type = (match && match.params && match.params.type) || ""
    return (
      <Container>
        <Fade
          onClick={() => this.handleConfirm()}
          dark
          innerRef={el => (this.fade = el)}
        />
        <Modal>
          <ConfirmBody innerRef={el => (this.body = el)}>
            <Header>
              <PrimaryHeading>
                <FormattedMessage id={`kiosk.confirmation.title.${type}`} />
              </PrimaryHeading>
              <SecondaryHeading>
                <FormattedMessage id={`kiosk.confirmation.subtitle.${type}`} />
              </SecondaryHeading>
            </Header>
            <Content>
              <ButtonGroup>
                <PrimaryButton onClick={this.handleConfirm}>
                  <FormattedMessage id={`kiosk.confirmation.confirm.${type}`} />
                </PrimaryButton>
              </ButtonGroup>
            </Content>
          </ConfirmBody>
        </Modal>
      </Container>
    )
  }
}

export default connect(null, {
  setModal
})(ConfirmationModal)



// WEBPACK FOOTER //
// ./src/Kiosk/ConfirmationModal/ConfirmationModal.js